export const UNGRADED_PART_TYPES = [
  "partTypeHtml",
  "partTypeScenario",
  "partTypeGame",
  "partTypeEmbeddedMedium",
];

export const LANGUAGES = ["en", "es"];

export const LANGUAGE = ["en"];

export const CONTROLS_LOADING_KEYS = [
  "return",
  "close",
  "save",
  "turnIn",
  "complete",
  "reset",
] as const;

export const PART_TYPE_WITH_LANGUAGE_SUFFIX_SET = new Set([
  "PartTypeGraphicOrganizer",
  "PartTypeDrawing",
  "PartTypeTable",
  "AssessmentBankQuestionGraphicOrganizer",
  "AssessmentBankQuestionDrawing",
]);

export const PART_TYPE_WITH_MULTI_ANSWER_SET = new Set([
  "AssessmentBankQuestionFreeFormFillInBlank",
  "PartTypeFreeFormFillInBlank",
  "AssessmentBankQuestionFillInBlank",
  "PartTypeFillInBlank",
  "AssessmentBankQuestionGriddable",
  "PartTypeGriddable",
]);

export const PART_TYPE_WIRH_JSON_ANSWER_SET = new Set([
  "PartTypeBarGraph",
  "PartTypeConceptMap",
  "PartTypeMultipleAnswerMultipleChoice",
  "PartTypeSequence",
]);

export const TEACHER = "Teacher";
export const STUDENT = "Student";
